import { render } from "./Loan.vue?vue&type=template&id=938d1f88"
import script from "./Loan.vue?vue&type=script&lang=js"
export * from "./Loan.vue?vue&type=script&lang=js"
script.render = render

export default script